import { Switch } from '@dc-shared-web/components/shadcn/switch'

export function LabeledSwitch({
  label,
  checked,
  onCheckedChange,
}: {
  label: string
  checked: boolean
  onCheckedChange: (c: boolean) => void
}) {
  return (
    <div className='tw-flex tw-items-center'>
      <Switch checked={checked} onCheckedChange={onCheckedChange} />
      <span className='tw-ml-2 tw-font-medium tw-text-neutral-700 tw-text-sm'>
        {label}
      </span>
    </div>
  )
}
